import React from 'react';

const MyHistroy = () => {
    return (
        <div>
            <h2>This is my Treatment History</h2>
        </div>
    );
};

export default MyHistroy;